<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/cZHRRa/tc-custom/9781398468092.jpg?1674929446284" alt="This image is the cover for the book 10 Ways to Please Your Mum"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">10 Ways to Please Your Mum
      </h1>
      <p class="bookDescription body article font2">
        <p>A delightful way of teaching your child how to count up to 10. Each picture is sure to bring a smile to your face. Your child can also have the added fun of counting the rabbits along the way.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Joan Whitehead
      </h2>
      
      <p class="authorDescription body article">Born and raised in the UK, Joan now lives in Western Australia, where she runs her own art and craft gallery. She has always enjoyed writing and illustrating children’s picture books and is delighted how this book has taken form. Also by Joan Whitehead: Step by step Transparent Art Not Green The four Seasons of Sammy Snail Flowery Thoughts Second Thoughts Piggy Tales</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5e81d858